import cx from 'classnames'

import { useThemeContext } from 'src/theme/themeProvider'

import classes from './styles.module.scss'

type Props = {
  progressPercent: number
  className?: string
}

export default function LoyaltyProgressBar({ progressPercent, className }: Props) {
  const { isDarkMode } = useThemeContext()
  const progress = progressPercent > 100 ? 100 : progressPercent

  return (
    <div className={cx(classes.track, isDarkMode && classes.isDarkMode, className)}>
      <div className={classes.bar} style={{ width: `${progress}%` }} />
      <div className={classes.thumb} style={{ left: `${progress}%` }}>
        <span className={classes.diamond} />
      </div>
    </div>
  )
}
